// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class EnvelopeDocument {
	public Item: any = null;
}